// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { CONFIG } from "~/config";
import ListComp from "./list-comp";
import DetailComp from "./detail-comp";
import { node } from "~/util/dom";
import { _ } from "~/i18n";

window.Places = class {
	_refreshOnActivate: boolean;

	constructor() {
		this._dom = {
			container: node("div",{ className: "places-main-cont" })
		};
		this._list = new ListComp(this);
		this._detail = new DetailComp(this);
		this._activeComp = null;
		this._mid = "";
		this._folderTitle = "";
		this._fromList = false;
		this._detailType = "";
		this._keepData = false;
		this._isActive = false;
		this._detailLock = false;
		this._wasLock = false;
		this._public = false;
		this._listData = [];
		this._showLabel = 0;
		this._refreshOnActivate = false;

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w((newUser, oldUser) => {
			// jakakoliv zmena uzivatele - prepnuti nebo logout
			if ((oldUser.user.userPublicId && newUser.user.userPublicId !== oldUser.user.userPublicId) || newUser.user.state !== 'green') {
				this._list.clearFolderId();
				this._list.keepData = false;
				if (this._activeComp) {
					this._activeComp.deactivate();
					this._activeComp = this._list;
				}
				this._mid = "";
			}

			// login
			if (newUser.user.userPublicId && newUser.user.state === 'green') {
				this.updateLikeList();
			// logout
			} else {
				this._detailLock = false;
				this._wasLock = false;
				this._listData = [];
				this._list.clear();
			}
		}));

		const { user } = store.getState().user;
		if (user.state === "green") {
			this.updateLikeList();
		}
	}

	destroy() {
		this.clear();
		this._dom.container.remove();
		this._storeUnsubscribe();
	}

	activate(actState) {
		if (this._isActive) return this;

		this._isActive = true;

		if (!this._activeComp) {
			this._activeComp = this._list;
		}

		this._setState(actState);
		Mapy.getComponent("logger").log("view", {text: "places"});

		return this;
	}

	deactivate() {
		if (!this._isActive || this._detailLock) return this;

		this._isActive = false;

		if (this._activeComp) {
			this._activeComp.deactivate(this._keepData);
		}

		return this;
	}

	get isActive() {
		return this._isActive;
	}

	set detailLock(state) {
		this._detailLock = state;
	}

	get showLabel() {
		return this._showLabel;
	}

	listRefreshData() {
		this._list.keepData = false;
		this._refreshOnActivate = true;
	}

	clear() {
		if (this._activeComp) {
			this._activeComp.clear();
		}
	}

	notifyLikeCreate(folderId) {
		if (this._activeComp) {
			this._activeComp.notifyLikeCreate(folderId);
		}
	}

	notifyLikeUpdate(id) {
		if (this._activeComp) {
			this._activeComp.notifyLikeUpdate();
		}
	}

	loadList() {
		this._list.notifyLikeUpdate();
	}

	get container() {
		return this._dom.container;
	}

	set state(state) {
		if (this._detailLock) {
			this._detail.refresh();
			this._detailLock = false;
			this._wasLock = true;
			return;
		}

		if ("x" in state && "y" in state && Mapy.getComponent("history").isFromHistory()) {
			this._wasLock = true;
		}

		let oldActiveComp = this._activeComp;

		this._mid = state.mid ? state.mid : "";
		this._folderTitle = state.folderTitle || "";
		this._fromList = state.fromList;
		this._activeComp = this._mid ? this._detail : this._list;
		this._detailType = state.dt || "";
		this._keepData = state.keepData || false;
		this._showLabel = "ol" in state ? parseInt(state.ol) : 0;

		if (oldActiveComp && this._activeComp != oldActiveComp) {
			oldActiveComp.deactivate(this._keepData);
		}

		// smazali jsme slozku, uvnitr rootu, chce to znovu nacist
		if (state.childFolderDelete) {
			this._list.keepData = false;
		}

		const { user } = store.getState().user;

		if (user.state !== "green") {
			Mapy.getComponent("mymaps").activeComponent(this, true);
		}

		this._setState(state.data ? { data: state.data } : {});
	}

	get state() {
		let state = {};

		if (this._mid) {
			state.mid = this._mid;
		}

		return state;
	}

	set isPublic(pub) {
		this._public = pub;
	}

	get isPublic() {
		return this._public;
	}

	get shareData() {
		let state = {
			title: _("mymap.switcher.saved"),
			type: "places-root"
		};

		if (this._mid) {
			state.mid = this._mid;
			state.type = "folder";

			Object.assign(state, this._activeComp.shareData);
		}

		return state;
	}

	changePublic(state) {
		this._activeComp.changePublic(state);
	}

	isSaved(item) {
		let data = [];

		for (let i = 0; i < this._listData.length; i++) {
			let it = this._listData[i];
			if (it.data.source == item.source && it.data.id == item.id) {
				let obj = JSON.parse(JSON.stringify(it));
				obj.data.liketype = obj.liketype;

				if (obj.liketype == "home" || obj.liketype == "work") {
					data.splice(0, 0, obj);
				}
				else {
					data.push(obj);
				}
			}
		}

		if (data.length) {
			return {
				...data[0].data,
				source_id: data[0].data.id,
				liketype: data[0].liketype,
				id: data[0].itemId,
			};
		}

		return null;
	}

	removeItemFromLikeList(source: string, id: number) {
		for (let i = 0; i < this._listData.length; i++) {
			let it = this._listData[i];

			if (it.data.source == source && it.data.id == id) {
				this._listData.splice(i, 1);
				break;
			}
		}
	}

	updateLikeList() {
		Mapy.ProviderMapyBox.listLikes().then(data => {
			if ("results" in data && data.results.length) {
				this._listData = data.results;
			}
		}, () => {});
	}

	addToLikeList(id, data) {
		let find = false;
		for (let i = 0; i < this._listData.length; i++) {
			let item = this._listData[i];

			if ("id" in item.data && "source" in item.data && item.data.id == data.id && item.data.source == data.source) {
				item.data.parent_name = _("detail.content.mymapsplace.saved2");
				delete item.data.parent_id;

				break;
			}
		}

		if (!find) {
			this._listData.push({ itemId: id, data, liketype: "like" });
		}
	}

	_setState(actState = {}) {
		if (!this._activeComp.active) {
			const { user } = store.getState().user;

			if (user.state === "green" || this._activeComp == this._detail) {
				this._activeComp.activate();
				this._activeComp.state = {
					mid: this._mid,
					folderTitle: this._folderTitle,
					fromList: this._fromList,
					detailType: this._detailType,
					keepData: this._keepData,
					zoomToItems: (!actState.disableZoom && !this._wasLock) || CONFIG.inFrame,
					data: actState.data || null,
				};
				this._keepData = false;
				this._wasLock = false;
			}
			else {
				Mapy.getComponent("mymaps").activeComponent();
			}
		} else {
			this._activeComp.activeSetState({
				refreshOnActivate: this._refreshOnActivate,
			});

			this._refreshOnActivate = false;
		}
	}
}
